/* eslint-disable react-hooks/exhaustive-deps */
//#region Styles
import { Row } from "components/styles";
//#endregion
//#region Components
import CustomSelect from "components/CustomSelect/CustomSelect";
//#endregion
//#region Services
//#endregion
//#region Utils
import { getOptionsToCustomSelect } from "components/CustomSelect/utils";
import { FILTER_STYLE_PROPS } from "./utils/constants";
import { RESOURCE_MODULE_IDS } from "config/constants";
import useChangeLibraryListByCampus from "views/Recursos/ResourcesLibrary/utils/hooks/useChangeLibraryListByCampus";
import useSettingsResourceScheduleAdminContext from "views/Configuracion/SettingsResourceScheduleAdmin/context/useSettingsResourceScheduleAdminContext";
//#endregion

const Filters = ({
    filters, spaceList
}) => {
    const { data } = useSettingsResourceScheduleAdminContext();
    const {
        campusList, resourceModuleList,
        libraryList, resourceTypes, spaceTypeList
    } = data;
    const {
        campusId, resourceModuleId,
        libraryId, resourceTypeId,
        spaceTypeId, spaceId
    } = filters.value;
    //#region Functions
    const { libraryListByCampus } = useChangeLibraryListByCampus({
        campusId: filters.value.campusId,
        changeLibraryField: filters.setLibraryId,
        libraryList
    });
    const renderFieldsRelativeToResourceModule = () => {
        if (resourceModuleId === RESOURCE_MODULE_IDS.LIBRARY) {
            return (
                <>
                    <CustomSelect
                        {...FILTER_STYLE_PROPS}
                        label="Biblioteca" defaultOptionText="Elige una Biblioteca"
                        value={libraryId} onChange={filters.setLibraryId}
                        optionsProps={getOptionsToCustomSelect(libraryListByCampus, { id: "id", text: "name" })}
                        disabled={libraryListByCampus.length === 0} />
                    <CustomSelect
                        {...FILTER_STYLE_PROPS.CUSTOM_SELECT}
                        label="Recurso" defaultOptionText="Elige un Recurso"
                        value={resourceTypeId} onChange={filters.setResourceTypeId}
                        optionsProps={getOptionsToCustomSelect(resourceTypes, { id: "id", text: "name" })}
                        required />
                </>
            );
        }
        else if (resourceModuleId === RESOURCE_MODULE_IDS.UNIVERSITY_SPACES)
            return (
                <>
                    <CustomSelect
                        {...FILTER_STYLE_PROPS}
                        label="Tipo de espacio" defaultOptionText="Elige una Tipo"
                        value={spaceTypeId} onChange={filters.setSpaceTypeId}
                        optionsProps={getOptionsToCustomSelect(spaceTypeList, { id: "id", text: "name" })}
                        disabled={spaceTypeList.length === 0} />
                    <CustomSelect
                        {...FILTER_STYLE_PROPS.CUSTOM_SELECT}
                        label="Nombre del espacio" defaultOptionText="Elige el nombre del espacio"
                        value={spaceId} onChange={filters.setSpaceId}
                        optionsProps={getOptionsToCustomSelect(spaceList, { id: "id", text: "name" })}
                        disabled={spaceList.length === 0}
                        required />
                </>
            );
        return null;
    }
    return (
        <Row justifyContent="flex-start">
            <CustomSelect
                {...FILTER_STYLE_PROPS.CUSTOM_SELECT}
                label="Campus"
                value={campusId}
                optionsProps={getOptionsToCustomSelect(campusList, { id: "id", text: "name" })}
                onChange={filters.setCampusId}
                defaultOptionText="Elige un Campus"
                disabled={campusList.length === 0 || filters.isUniqueCampus} />
            <CustomSelect
                {...FILTER_STYLE_PROPS.CUSTOM_SELECT}
                label="Módulo"
                value={resourceModuleId}
                optionsProps={getOptionsToCustomSelect(resourceModuleList, { id: "id", text: "name" })}
                onChange={filters.setResourceModuleId}
                defaultOptionText="Elige un módulo"
                disabled={resourceModuleList.length <= 1}
                required />
            {renderFieldsRelativeToResourceModule()}
        </Row>
    );
}

export default Filters;